import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useTabData from 'hooks/Flux/About/useTabData';
import { Row, Tab, Tabs } from 'react-bootstrap';
import CentralizedSpinner from 'components/CentralizedSpinner';
import AboutSection from 'components/Flux/About/AboutSection';
import AboutMobile from 'components/Flux/About/Mobile';
import useIsMobile from 'utils/hooks/useIsMobile';
import { resolveAboutTabKey } from 'helper/flux/about';
import './index.scss';

export default function About() {
  const { instructionTabs, isLoading } = useTabData();
  const [searchParams] = useSearchParams();
  const [selectedTab, setSelectedTab] = useState<string | null>(null);
  const key = selectedTab ?? resolveAboutTabKey(instructionTabs, searchParams.get('tab'));
  const isMobile = useIsMobile();

  if (isMobile) {
    return <AboutMobile instructionTabs={instructionTabs} isLoading={isLoading} />;
  }

  return (
    <>
      <Row>
        <h1>SOBRE</h1>
      </Row>
      {isLoading && <CentralizedSpinner />}
      {instructionTabs?.length && (
        <Row className="flux-about-tab-container">
          <Tabs
            activeKey={key || instructionTabs[0].id}
            onSelect={(k) => setSelectedTab(k)}
            transition={false}
            id="flux-about-tabs"
            className="tabbed-page gap-1 title-semi-bold"
          >
            {instructionTabs.map((tab) => (
              <Tab
                key={tab.id}
                eventKey={tab.id}
                title={tab.title.toUpperCase()}
                className="p-4"
              >
                <AboutSection tab={tab} activeKey={key || String(instructionTabs[0].id)} />
              </Tab>
            ))}
          </Tabs>
        </Row>
      )}
    </>
  );
}
